import { Observable } from 'rxjs';

import { Acls, CatalogObjectTypes, PermAccessLevelString, UserResponseData } from '@mirage-projects/cw-models';

/**
 * Abstract service definition to manage the user endpoints
 */
export abstract class UserService {
    /**
     * Get the user by id
     * @param id User id
     */
    abstract get(id: string): Observable<UserResponseData>;

    /**
     * Get the list of users
     */
    abstract getAll(): Observable<UserResponseData[]>;

    /**
     * Add user permission
     */
    abstract addUserPermission(userId: string, objectId: number, objectType: string, objEffect: PermAccessLevelString): Observable<void>;

    /**
     * Delete user permission
     */
    abstract deleteUserPermission(userId: string, objectId: number, objectType: CatalogObjectTypes): Observable<void>;

    /**
     * Add user Acl
     */
    abstract addUserAcl(userId: string, acl: Acls): Observable<void>;

    /**
     * Delete user Acl
     */
    abstract deleteUserAcl(userId: string, aclId: string): Observable<void>;
}
